'use strict';

export default {
    id: null,
    address: {},

    /**
     * Initialise the existing id
     * @param {string} id
     */
    for(id) {
        this.id = id;
        return this;
    },

    /**
     * Set the address
     * @param {Object} address
     */
    set(address) {
        this.address = address;
        return this;
    },

    save() {
        let payload = this.address;
        payload.id = this.id;

        return new Promise((resolve, reject) => {
            axios({
                method: 'POST',
                url: '/api/users/addresses',
                headers: {
                    'Accept': 'application/json'
                },
                data: payload
            }).then(response => {
                resolve(response);
            }).catch(errors => {
                reject(errors.response.data);
            });
        });
    },

    delete() {
        return new Promise((resolve, reject) => {
            axios({
                method: 'DELETE',
                url: '/api/users/addresses/' + this.id,
                headers: {
                    'Accept': 'application/json'
                }
            }).then(response => {
                resolve(response);
            }).catch(errors => {
                reject(errors.response.data);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Account/Address.js